import {
  TrendingUp, CalendarClock, ArrowRightLeft, Landmark, Users,
  AlertOctagon, BookOpen, ArrowDownLeft, ArrowUpRight, FileInput, FileOutput, Scale,
} from "lucide-react";

/* --------- Report catalog (sectioned) --------- */
export const CATALOG = [
  {
    label: "Overview",
    items: [
      { key: "investment_summary", title: "Investment Summary", desc: "All investments — invested, value, profit, return.", icon: TrendingUp },
      { key: "monthly_income", title: "Monthly Income", desc: "Month-wise income for the FY, per investment.", icon: CalendarClock },
      { key: "net_worth", title: "Net Worth", desc: "Company totals as of today.", icon: Landmark },
      { key: "pnl", title: "Profit & Loss", desc: "Income vs expense by category.", icon: Scale },
    ],
  },
  {
    label: "Books",
    items: [
      { key: "day_book", title: "Day Book", desc: "Every cash & bank entry, chronological.", icon: BookOpen },
      { key: "receipts", title: "Receipt Register", desc: "All money received (incoming).", icon: ArrowDownLeft },
      { key: "payments", title: "Payment Register", desc: "All money paid out (outgoing).", icon: ArrowUpRight },
      { key: "cash_flow", title: "Cash Flow", desc: "Money in vs out, chronological.", icon: ArrowRightLeft },
    ],
  },
  {
    label: "GST & Trade",
    items: [
      { key: "purchase_register", title: "Purchase Register", desc: "Bills received — GST, paid, outstanding.", icon: FileInput },
      { key: "sales_register", title: "Sales Register", desc: "Invoices raised — GST, received, outstanding.", icon: FileOutput },
      { key: "outstanding", title: "Outstanding", desc: "Bills / invoices still open.", icon: AlertOctagon },
    ],
  },
  {
    label: "Ownership",
    items: [
      { key: "partner_statement", title: "Partner Statement", desc: "Per-partner capital, profit, paid out.", icon: Users },
      { key: "pending", title: "Pending / Overdue", desc: "Loan late payments, missing entries.", icon: AlertOctagon },
    ],
  },
];

export const REPORT_BY_KEY = Object.fromEntries(
  CATALOG.flatMap((g) => g.items.map((r) => [r.key, r]))
);

/* --------- Date preset helpers --------- */
const iso = (d) => d.toISOString().slice(0, 10);
const startOf = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

export function presetRange(kind) {
  const now = startOf(new Date());
  const yy = now.getFullYear();
  const mm = now.getMonth();
  switch (kind) {
    case "today": return [iso(now), iso(now)];
    case "yesterday": { const y = new Date(now); y.setDate(y.getDate() - 1); return [iso(y), iso(y)]; }
    case "this_month": return [iso(new Date(yy, mm, 1)), iso(new Date(yy, mm + 1, 0))];
    case "last_month": return [iso(new Date(yy, mm - 1, 1)), iso(new Date(yy, mm, 0))];
    case "this_fy": { const fs = mm >= 3 ? yy : yy - 1; return [iso(new Date(fs, 3, 1)), iso(new Date(fs + 1, 2, 31))]; }
    case "last_fy": { const fs = mm >= 3 ? yy - 1 : yy - 2; return [iso(new Date(fs, 3, 1)), iso(new Date(fs + 1, 2, 31))]; }
    case "ytd": return [iso(new Date(yy, 0, 1)), iso(now)];
    case "all": return ["", ""];
    default: return ["", ""];
  }
}

export const PRESETS = [
  ["today", "Today"], ["yesterday", "Yday"],
  ["this_month", "M"], ["last_month", "-M"],
  ["this_fy", "FY"], ["last_fy", "-FY"],
  ["ytd", "YTD"], ["all", "All"],
];

/* --------- Cell helpers --------- */
export const isNumeric = (v) => typeof v === "number" && Number.isFinite(v);

export const looksLikeMoney = (colName) => {
  const c = colName.toLowerCase();
  return /amount|total|invested|value|profit|paid|received|outstanding|balance|share|capital|subtotal|gst|due/.test(c);
};

export const isTotalRow = (row) => Object.values(row).some(
  (v) => typeof v === "string" && v.trim().startsWith("— ") && v.trim().endsWith(" —")
);
